import './styles/App.css';
import './styles/gallery.css';
import React from 'react'
import { ethers } from 'ethers';
import { useState , useEffect} from 'react';
import connector from './utils.js'
import {Link} from 'react-router-dom';
import Button from '@mui/material/Button';

function Profile(props) {
  const [contract, setContract]=useState('undefined');
  const [signer,setSigner] = useState('');
  const [signerAd,setSignerAd] = useState('');
  const [provider,setProvider] = useState('');
  const [accounts,setAccounts] = useState([]);
  const [presents,setPresents] = useState([]);
  useEffect(() => {
    const init = async()=>{
      const lis = await connector(props.address);
      setContract(await lis.contract);
      setProvider(await lis.provider);
      setAccounts(await lis.accounts);
      setSigner(await lis.signer)
      
    }
    init();
    
  },[]);
  useEffect(()=>{
    const getPresents = async()=>{
      var id = await contract.connect(signer).startId();
      var presents = [];
      for (var i = 1; i<id;i++){
        var pres = await contract.connect(signer).idToPresent(i);
        presents.push(pres); 
      }
      setPresents(presents);
      const addr = await signer.getAddress()
      setSignerAd(await addr)
    }
    getPresents();
  },[contract])
  
  function display (){
    let created =[]
    for (let i =0; i <presents.length ;i++){
      let pr = presents[i]
      var des = pr.desc;
      var neDe = pr.desc;
      if(des.length>=30){
        neDe= des.substring(0, 30) + "..."
      }
      let gender;
      if(pr.gender == 1){
        gender = "♀"
      }
      if(pr.gender == 2){
        gender = "♂"
      }
      if(pr.gender == 3){
        gender = "⚥"
      }
      let label = pr.name + " . " + pr.price
      let lael = pr.age + " , " + gender+"        "+pr.rating +"⭐"
      let pathP = "/"+pr.id; 
      var gifter = ethers.utils.getAddress(pr.gifter);
      var acc = ethers.utils.getAddress(accounts[0]);
      if (gifter==acc){
        created.push(
            <Link to={pathP} id='photoLink'> 
            <div>
                <img id = "itemPhoto" src= {pr.photo}></img>
                <div id ="itemInfo">
                <p id ="itemName" className='tee'>{label}</p>
                <pre id ="itemAge" className='tee'>{lael}</pre>
                </div>
            </div>
            </Link>
        )
      }
    }
    return(created)
  }
  
 
  return (
    <div className='App'>
    <link href="https://fonts.googleapis.com/css2?family=Lato:wght@900&display=swap" rel="stylesheet"></link>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"></link>
    <nav>
      <div className='linkButton' id ='linkbutton'>
        <Link to ="/" id="homeLink" className='homelink'></Link>
        <Link to ="/" id="logo"></Link>      
        <Link to="/add" id = "addLink">
          <button id = 'addButt'>ADD PRESENT</button>
        </Link>  
        <Link to="/profile" id = "profLink">
          <button id = 'profButt'>PROFILE</button>
        </Link>  
      </div>
    </nav>
    <h3 id ="itemName" className='tee'> ITEMS YOU HAVE CREATED </h3>
    <div id = "gridDesign">
      {display()}
    </div>
    
    </div>
  );
}
export default Profile
